export const FACEBOOK = 'facebook';
export const INSTAGRAM = 'instagram';
export const TEXT = '';
export const TUMBLR = 'tumblr';
export const TWITTER = 'twitter';



/** WEBPACK FOOTER **
 ** ./src/show-page/constants/more-link-type.js
 **/